import { TransfersAction } from '@qirapagos/web/src/store/transfers/types'

export const updateAlias = (alias: string) => ({
  type: TransfersAction.UPDATE_ALIAS,
  payload: alias
})
